export default __webpack_public_path__ + "static/media/Anova-Bold.a7be232f.woff2";